import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import {
  CountData,
  GrnHistoryData,
  ListData,
  ManageStockLogs,
  ProductGrnItems,
  ProductsGrn,
  StockConfig,
  StockData,
  StockMovementListData,
} from './types'

export const selectStockListEvent = (state: RootState): Event => state.stockReducer.listEvent

export const selectStockList = (state: RootState): ListData => state.stockReducer.list

export const selectStockActionEvent = (state: RootState): Event => state.stockReducer.actionEvent

export const selectStockDetail = (state: RootState): StockData | undefined => state.stockReducer.detail

export const selectStockDetailEvent = (state: RootState): Event => state.stockReducer.detailEvent

export const selectGrnHistoryListEvent = (state: RootState): Event => state.stockReducer.grnHistoryEvent

export const selectGrnHistoryList = (state: RootState): GrnHistoryData[] => state.stockReducer.grnHistory

export const selectProductGrnList = (state: RootState): ProductGrnItems[] => state.stockReducer.grnList.data

export const selectStockLogs = (state: RootState): ManageStockLogs => state.stockReducer.manageStockLogs.logs

export const selectStockLogsEvent = (state: RootState): Event => state.stockReducer.manageStockLogs.event

export const selectProductsGrnList = (state: RootState): ProductsGrn[] =>
  state.stockReducer.productsGrnList.data

export const selectProductsGrnEvent = (state: RootState): Event => state.stockReducer.productsGrnList.event

export const selectStockMovementList = (state: RootState): StockMovementListData =>
  state.stockReducer.stockMovement.data

export const selectStockMovementEvent = (state: RootState): Event => state.stockReducer.stockMovement.event

export const selectStockConfigDatail = (state: RootState): StockConfig => state.stockReducer.stockConfigData

export const selectDelteConfigEvent = (state: RootState): Event => state.stockReducer.deleteEvent

export const selectActionEvent = (state: RootState): Event => state.stockReducer.actionEvent

export const selectCountData = (state: RootState): CountData | undefined => state.stockReducer.countData
